import {useEffect, useRef} from 'react';

export const useOnUpdate = (callback: () => any | Promise<any>, deps: unknown[]) => {
  const isFirst = useRef(true);
  useEffect(() => {
    if (!isFirst.current) {
      callback();
    }
  }, deps);

  useEffect(() => {
    isFirst.current = false;
  }, []);
};
